/*jshint esversion: 6 */
import store from '@/store/index';

function Template(payload) {
  let route = {
    path: 'editcalendar',
    name: 'EditCalendar',
    components: {
      side_bar: () => import( /* webpackChunkName: "ProjectTaktPlanWaggonInfoBox" */ '@/views/Project/TaktPlanWorkPackage/CalendarSideBar.view.vue'),
    },
    props: {
      side_bar: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          project: store.state.Ultra.projects[route.params.project_id]
        };
      },
    },
    meta: {
      requiresAuth: true
    },
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
